import { createAction } from 'redux-actions';
export var SET_LOCATION = 'SCHEDULE_FORM/SET_LOCATION';
export var SWITCH_LOCATION = 'SCHEDULE_FORM/SWITCH_LOCATION';
export var setLocation = createAction(SET_LOCATION);
export var switchLocation = createAction(SWITCH_LOCATION);
